import React from "react";
import HistoryTimeline from "../components/History";

const History = () => (
  <>
    <div id="page-top" />
    <HistoryTimeline />
  </>
);

export default History;
